var React = require('react');

function Chain (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.12 5.825a3.5 3.5 0 00-5.09-4.8l-.88.88a4.508 4.508 0 012.425.418A1.5 1.5 0 019.682 4.43l-.048.057-.069.074-2.12 2.121-.115.103a1.501 1.501 0 01-1.66.157l-.09-.054-.143-.103-.114-.103-.116-.13a1.491 1.491 0 01-.178-.285L3.58 7.717c.099.133.208.26.329.38l.129.122.16.136.09.07a3.5 3.5 0 004.57-.329l2.122-2.121.14-.15zM7.808 3.646l-.09-.07a3.5 3.5 0 00-4.57.33l-2.122 2.12-.141.15a3.5 3.5 0 005.09 4.8l.881-.88a4.508 4.508 0 01-2.425-.418 1.5 1.5 0 01-2.107-2.107l.047-.057.07-.073 2.12-2.122.115-.103a1.501 1.501 0 011.66-.156l.09.053.143.103.114.103.115.13c.071.09.13.185.178.285l1.45-1.45a3.53 3.53 0 00-.458-.502L7.93 3.75l-.124-.104z","fill":"currentColor"}));
}

Chain.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Chain;

Chain.default = Chain;
